(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bltac-contact-anchor"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getStickyOffset() {
      var selectors = [
        '#shopify-section-header',
        '.shopify-section-group-header-group',
        '.site-header',
        '.header-wrapper',
        'header[role="banner"]',
        'header'
      ];
      var stickyBottom = 0;

      selectors.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (element) {
          var style = window.getComputedStyle(element);
          var rect = element.getBoundingClientRect();
          var isSticky = style.position === 'fixed' || style.position === 'sticky';

          if (isSticky && rect.height && rect.top <= 120) {
            stickyBottom = Math.max(stickyBottom, rect.bottom);
          }
        });
      });

      var fallback = window.matchMedia('(max-width: 640px)').matches ? 132 : 112;
      return Math.max(stickyBottom + 18, fallback);
    }

    function scrollToAnchor(anchor) {
      window.requestAnimationFrame(function () {
        var top = anchor.getBoundingClientRect().top + window.pageYOffset - getStickyOffset();
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      });
    }

    function getItems() {
      return Array.prototype.slice.call(document.querySelectorAll('[data-bltac-contact-accordion]')).map(function (accordion) {
        var section = accordion.closest('.shopify-section');
        var panel = section ? section.nextElementSibling : null;
        var id = accordion.getAttribute('data-anchor-id');

        if (panel) {
          panel.classList.add('bltac-contact-accordion-panel');
          panel.setAttribute('data-bltac-contact-panel', id);
        }

        return {
          accordion: accordion,
          anchor: accordion.querySelector('.bltac-contact-accordion__anchor'),
          button: accordion.querySelector('.bltac-contact-accordion__summary'),
          defaultOpen: accordion.getAttribute('data-default-open') === 'true',
          id: id,
          panel: panel
        };
      }).filter(function (item) {
        return item.id && item.panel && item.button;
      });
    }

    function selectPanel(id, shouldScroll) {
      var items = getItems();
      var selectedItem = null;

      items.forEach(function (item) {
        var isSelected = item.id === id;

        if (isSelected) {
          selectedItem = item;
        }

        item.accordion.classList.toggle('is-active', isSelected);
        item.button.setAttribute('aria-expanded', isSelected ? 'true' : 'false');
        item.panel.classList.toggle('is-collapsed', !isSelected);

        document.querySelectorAll('.bltac-contact-hub__quick-link[href="#' + item.id + '"]').forEach(function (card) {
          card.classList.toggle('is-active', isSelected);
        });
      });

      if (selectedItem && shouldScroll) {
        scrollToAnchor(selectedItem.anchor || selectedItem.accordion);
      }
    }

    function initContactAccordions() {
      var items = getItems();

      if (!items.length) {
        return;
      }

      items.forEach(function (item) {
        if (item.button.dataset.bltacAccordionReady === 'true') {
          return;
        }

        item.button.dataset.bltacAccordionReady = 'true';
        item.button.addEventListener('click', function () {
          selectPanel(item.id, true);

          if (window.history && window.history.pushState) {
            window.history.pushState(null, '', '#' + item.id);
          }
        });
      });

      var hashId = window.location.hash ? window.location.hash.slice(1) : null;
      var defaultItem = items.find(function (item) { return item.id === hashId; }) || items.find(function (item) { return item.defaultOpen; }) || items[0];

      selectPanel(defaultItem.id, false);
    }

    document.addEventListener('bltac:contact:select', function (event) {
      if (event.detail && event.detail.id) {
        selectPanel(event.detail.id, false);
      }
    });

    initContactAccordions();

    document.addEventListener('shopify:section:load', initContactAccordions);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bltac-contact-hub"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getStickyOffset() {
      var selectors = [
        '#shopify-section-header',
        '.shopify-section-group-header-group',
        '.site-header',
        '.header-wrapper',
        'header[role="banner"]',
        'header'
      ];
      var stickyBottom = 0;

      selectors.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (element) {
          var style = window.getComputedStyle(element);
          var rect = element.getBoundingClientRect();
          var isSticky = style.position === 'fixed' || style.position === 'sticky';

          if (isSticky && rect.height && rect.top <= 120) {
            stickyBottom = Math.max(stickyBottom, rect.bottom);
          }
        });
      });

      var fallback = window.matchMedia('(max-width: 640px)').matches ? 132 : 112;
      return Math.max(stickyBottom + 18, fallback);
    }

    function scrollToTarget(target) {
      window.requestAnimationFrame(function () {
        var top = target.getBoundingClientRect().top + window.pageYOffset - getStickyOffset();
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      });
    }

    function initContactHub(section) {
      if (section.dataset.bltacContactReady === 'true') {
        return;
      }

      section.dataset.bltacContactReady = 'true';

      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-bltac-contact-anchor]'));

      function setActiveCard(id) {
        cards.forEach(function (card) {
          card.classList.toggle('is-active', card.getAttribute('href') === '#' + id);
        });
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function (event) {
          var id = card.getAttribute('href').slice(1);
          var target = document.getElementById(id);

          if (!target) {
            return;
          }

          event.preventDefault();
          setActiveCard(id);
          document.dispatchEvent(new CustomEvent('bltac:contact:select', { detail: { id: id } }));
          scrollToTarget(target);

          if (window.history && window.history.pushState) {
            window.history.pushState(null, '', '#' + id);
          }
        });
      });

      if (window.location.hash) {
        setActiveCard(window.location.hash.slice(1));
      }
    }

    document.querySelectorAll('[data-section-type="bltac-contact-hub"]').forEach(initContactHub);

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-section-type="bltac-contact-hub"]');

      if (section) {
        initContactHub(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bltac-faq-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function normalise(value) {
      return (value || '').toString().toLowerCase().trim();
    }

    function initFaqPage(section) {
      if (!section || section.dataset.bltacFaqReady === 'true') {
        return;
      }

      section.dataset.bltacFaqReady = 'true';

      var searchInput = section.querySelector('[data-faq-search]');
      var filterButtons = Array.prototype.slice.call(section.querySelectorAll('[data-faq-filter]'));
      var categories = Array.prototype.slice.call(section.querySelectorAll('[data-faq-category]'));
      var noResults = section.querySelector('[data-faq-no-results]');
      var activeFilter = 'all';

      function applyFilters() {
        var query = normalise(searchInput ? searchInput.value : '');
        var totalVisible = 0;

        categories.forEach(function (category) {
          var visibleInCategory = 0;
          var items = Array.prototype.slice.call(category.querySelectorAll('[data-faq-item]'));

          items.forEach(function (item) {
            var categoryName = item.getAttribute('data-faq-item-category');
            var categoryMatches = activeFilter === 'all' || categoryName === activeFilter;
            var searchMatches = !query || normalise(item.textContent).indexOf(query) !== -1;
            var isVisible = categoryMatches && searchMatches;

            item.hidden = !isVisible;

            if (isVisible) {
              visibleInCategory += 1;
              totalVisible += 1;
            }
          });

          category.hidden = visibleInCategory === 0;
        });

        if (noResults) {
          noResults.hidden = totalVisible > 0;
        }
      }

      filterButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          activeFilter = button.getAttribute('data-faq-filter') || 'all';

          filterButtons.forEach(function (candidate) {
            var isActive = candidate === button;
            candidate.classList.toggle('is-active', isActive);
            candidate.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          applyFilters();
        });
      });

      if (searchInput) {
        searchInput.addEventListener('input', applyFilters);
      }

      applyFilters();
    }

    document.querySelectorAll('[data-section-type="bltac-faq-page"]').forEach(initFaqPage);

    document.addEventListener('shopify:section:load', function (event) {
      initFaqPage(event.target.querySelector('[data-section-type="bltac-faq-page"]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
